export default "__VITE_ASSET__CFnAZ6WL__"